import Vue from 'vue';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets
// import ElementUI from 'element-ui'; // 饿了么团队样式
// import 'element-ui/lib/theme-chalk/index.css';
import '@/common/scss/index.scss'; // 样式入口
import '@/plugins/lockr'; // 引入lockr用于本地存储
import App from './App.vue'; // 入口页
import router from './router'; // vue-router
import store from './store'; // vuex
import './permission'; // 路由权限控制
import '@/common/icons'; // 注册svg图标组件
import '@/utils/prototype-extend'; // 引入对Array、Object等的prototype进行的扩展方法
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import MetaInfo from 'vue-meta-info';

Vue.config.productionTip = false;

// 初始化vuex的store，从本地存储（localStorage）中载入记录的信息
store.dispatch('appLoad');

// Vue.use(ElementUI);
Vue.use(MetaInfo);

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app');
